import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import { useBreadcrumbTrail } from '../../context/BreadcrumbContext';

import styles from './PageLayout.module.css';

const PageLayout = ({
  children,
  title,
  headerAccessoryView,
  footerView,
}: {
  children;
  title?;
  headerAccessoryView?;
  footerView?;
}) => {
  const trail = useBreadcrumbTrail();

  const breadcrumbItems = trail.map((entry, idx) => {
    const isLast = idx === trail.length - 1;
    return isLast
      ? { title: <span data-testid="breadcrumb-current">{entry.label}</span> }
      : { title: <Link to={entry.path} data-testid="breadcrumb-link" data-path={entry.path}>{entry.label}</Link> };
  });

  return (
    <div className={styles.page}>
      {(title || headerAccessoryView || trail.length > 0) && (
        <div className={styles.headerCard}>
          {trail.length > 0 && (
            <Breadcrumb items={breadcrumbItems} className={styles.breadcrumb} data-testid="breadcrumb" />
          )}
          <div className={styles.headerRow}>
            <div className={styles.headerTitle} data-testid="page-title">{title}</div>
            {headerAccessoryView && (
              <div className={styles.headerAccessoryView}>{headerAccessoryView}</div>
            )}
          </div>
        </div>
      )}

      {children}

      <div className={styles.footerBar}>
        {footerView && <div className={styles.footerView}>{footerView}</div>}
      </div>
    </div>
  );
};

export default PageLayout;
